import "./Toggle.scss";

import React, { Component } from "react";
import clsx from "clsx";

import Text from "../../common/Text/Text";

class Toggle extends Component {
	state = {
		selected: 0,
	};

	componentDidMount() {
		if (this.props.default) {
			this.setState({ selected: this.props.default });
		}
	}

	handleSelect(index) {
		if (this.props.disabled) {
			return;
		}

		this.setState({ selected: index }, () => {
			if (typeof this.props.afterChange !== "function") {
				return;
			}

			this.props.afterChange({ index, value: this.props.options[index] });
		});
	}

	render() {
		const { options, className, value, disabled } = this.props;
		const { selected } = this.state;
		const selectedItem = value ?? selected;

		return (
			<div
				className={clsx(
					"Toggle --pdf-ignore",
					{ "--disabled": disabled },
					className,
				)}
			>
				{options.map((option, index) => (
					<div
						key={`Toggle-option_${index}`}
						className={clsx("Toggle__option", {
							"--selected": selectedItem === index,
						})}
						onClick={() => this.handleSelect(index)}
						role={"switch"}
						tabIndex={index}
						aria-checked={selectedItem === index}
					>
						<Text tag={"p"} className={"Toggle__label"}>
							{option}
						</Text>
					</div>
				))}
			</div>
		);
	}
}

export default Toggle;
